(() => {
  'use strict';
  const root = document.querySelector('[data-bp-root]');
  if (!root || root.dataset.bpReady) return;
  const $ = selector => root.querySelector(selector);
  const all = selector => [...root.querySelectorAll(selector)];
  const config = JSON.parse($('[data-bp-config]').textContent);
  const strings = config.strings;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const gallery = $('[data-bp-gallery]');
  if (gallery) {
    const thumbs = [...gallery.querySelectorAll('[data-bp-thumb]')];
    const main = gallery.querySelector('[data-bp-gallery-main]');
    const mainImage = main.querySelector('img');
    const dialog = gallery.querySelector('[data-bp-gallery-dialog]');
    const expanded = gallery.querySelector('[data-bp-gallery-expanded]');
    let active = 0;
    thumbs.forEach(thumb => { thumb.setAttribute('role', 'button'); thumb.removeAttribute('aria-current'); });
    main.setAttribute('role', 'button');
    function select(index, focus = false) {
      active = (index + thumbs.length) % thumbs.length;
      const selected = thumbs[active];
      main.href = selected.dataset.full;
      mainImage.srcset = selected.dataset.srcset;
      mainImage.src = selected.dataset.src;
      mainImage.alt = selected.dataset.alt;
      const isVideo = ['video', 'external_video'].includes(selected.dataset.kind);
      gallery.querySelector('[data-bp-gallery-action]').textContent = isVideo ? '▶' : '+';
      main.setAttribute('aria-label', isVideo ? selected.getAttribute('aria-label') : gallery.dataset.enlarge);
      gallery.querySelector('[data-bp-gallery-count]').textContent = active + 1;
      thumbs.forEach((thumb, i) => { thumb.setAttribute('aria-pressed', String(i === active)); thumb.tabIndex = i === active ? 0 : -1; });
      // Scroll only the thumbnail strip. Do not move the page when an image changes.
      const strip = selected.parentElement;
      if (selected.offsetLeft < strip.scrollLeft || selected.offsetLeft + selected.offsetWidth > strip.scrollLeft + strip.clientWidth) {
        // Keep thumbnails still during rapid pointer or keyboard selection.
        strip.scrollTo({left:selected.offsetLeft - (strip.clientWidth - selected.offsetWidth) / 2, behavior:'instant'});
      }
      if (focus) selected.focus({preventScroll:true});
    }
    gallery.dataset.enlarge = main.getAttribute('aria-label');
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', event => { event.preventDefault(); select(index); });
      thumb.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); select(index); }
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        select(event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1), true);
      });
    });
    gallery.querySelector('[data-bp-gallery-prev]').addEventListener('click', () => select(active - 1));
    gallery.querySelector('[data-bp-gallery-next]').addEventListener('click', () => select(active + 1));
    function enlarge(event) {
      event.preventDefault();
      expanded.replaceChildren();
      const template = gallery.querySelector(`[data-bp-gallery-video="${active}"]`);
      if (template) expanded.append(template.content.cloneNode(true));
      else { const image = new Image(); image.src = thumbs[active].dataset.full; image.alt = thumbs[active].dataset.alt; expanded.append(image); }
      dialog.showModal();
      gallery.querySelector('[data-bp-gallery-close]').focus({preventScroll:true});
      const video = expanded.querySelector('video');
      if (video) video.play().catch(() => { /* Native controls remain available if autoplay is blocked. */ });
    }
    main.addEventListener('click', enlarge);
    main.addEventListener('keydown', event => { if (event.key === ' ') enlarge(event); });
    gallery.querySelector('[data-bp-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { expanded.replaceChildren(); main.focus({preventScroll:true}); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    gallery.querySelector('[data-bp-gallery-nav]').hidden = false;
    select(0);
    const visual = gallery.closest('.product-visual');
    function fitGallery() {
      const header = parseFloat(getComputedStyle(root).getPropertyValue('--sf-header')) || 140;
      // A tall gallery must scroll normally so its thumbnails and lab link stay reachable.
      visual.toggleAttribute('data-bp-gallery-sticky', innerWidth > 940 && visual.offsetHeight + header + 108 < innerHeight);
    }
    new ResizeObserver(fitGallery).observe(visual);
    addEventListener('resize', fitGallery);
    fitGallery();
  }
  const benefitsDialog = $('[data-bp-benefits-dialog]');
  let benefitsTrigger;
  if (benefitsDialog) {
    $('#bp-dialog-title').textContent = $('#bp-benefits-detail summary').textContent;
    all('[data-bp-benefits-open]').forEach(trigger => trigger.addEventListener('click', event => {
      event.preventDefault(); benefitsTrigger = trigger; benefitsDialog.showModal();
      $('[data-bp-benefits-body]').scrollTop = 0;
      $('[data-bp-benefits-close]').focus({preventScroll:true});
    }));
    $('[data-bp-benefits-close]').addEventListener('click', () => benefitsDialog.close());
    benefitsDialog.addEventListener('close', () => benefitsTrigger?.focus({preventScroll:true}));
    benefitsDialog.addEventListener('click', event => {
      if (event.target !== benefitsDialog) return;
      const box = benefitsDialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) benefitsDialog.close();
    });
  }
  const currencyFormat = new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency});
  const money = cents => currencyFormat.format(cents / 100);
  all('[data-bp-gift-summary]').forEach(summary => {
    summary.textContent = summary.dataset.template.replace('[count]', summary.dataset.count).replace('[value]', money(Number(summary.dataset.value)));
  });
  all('[data-bp-gift-price]').forEach(price => { price.textContent = money(Number(price.dataset.bpGiftPrice)); });
  function renderPurchase(announce) {
    const quantity = Number($('input[name="bundle_quantity"]:checked').value);
    const subscription = $('input[name="bundle_purchase_type"]:checked').value === 'subscription';
    const reference = config.reference * quantity;
    const total = config.subscription * quantity;
    const selection = quantity === 1 ? strings.deliverySingle : strings.delivery.replace('[count]', quantity);
    const onceSelection = quantity === 1 ? strings.onceDeliverySingle : strings.onceDelivery.replace('[count]', quantity);
    $('[data-bp-sub-total]').textContent = money(total);
    $('[data-bp-sub-list]').textContent = money(reference);
    $('[data-bp-sub-day]').textContent = money(total / 30);
    $('[data-bp-once-total]').textContent = money(reference);
    $('[data-bp-once-day]').textContent = money(reference / 30);
    all('[data-bp-day-label]').forEach(label => { label.textContent = quantity > 1 ? strings.dayTotal : strings.day; });
    $('[data-bp-cancel-link]').hidden = !subscription;
    $('[data-bp-quantity]').textContent = selection;
    $('[data-bp-once-quantity]').textContent = onceSelection;
    $('[data-bp-cta]').textContent = subscription ? strings.start : strings.add;
    $('[data-bp-sub-detail]').hidden = false;
    if ($('.bp-gifts')) $('.bp-gifts').hidden = !subscription;
    $('[data-bp-once-detail]').hidden = subscription;
    if (!subscription && $('.bp-gifts')) $('.bp-gifts').open = false;
    $('[data-bp-renewal]').textContent = subscription ? strings.renewal.replace('[price]', money(total)) : strings.once;
    all('[data-bp-plan]').forEach(card => card.classList.toggle('selected', (card.dataset.bpPlan === 'subscription') === subscription));
    $('[data-bp-sticky-plan]').textContent = subscription ? selection : onceSelection;
    $('[data-bp-sticky-selection]').textContent = subscription ? selection : onceSelection;
    $('[data-bp-sticky-discount]').hidden = !subscription;
    $('[data-bp-sticky-total]').textContent = money(subscription ? total : reference);
    $('[data-bp-sticky-list]').textContent = money(reference);
    $('[data-bp-sticky-list]').hidden = !subscription;
    $('[data-bp-sticky-day]').textContent = money((subscription ? total : reference) / 30) + (quantity > 1 ? strings.dayTotal : strings.day);
    $('[data-bp-sticky-cta]').textContent = subscription ? strings.start : strings.add;
    $('[data-bp-sticky]').classList.toggle('is-one-time', !subscription);
    if (announce) $('[data-bp-price-status]').textContent = `${subscription ? strings.start : strings.add}. ${money(subscription ? total : reference)}.`;
  }
  all('input[name="bundle_quantity"],input[name="bundle_purchase_type"]').forEach(input => input.addEventListener('change', () => renderPurchase(true)));
  all('[data-bp-plan]').forEach(card => card.addEventListener('click', event => {
    if (event.defaultPrevented || event.target.closest('a,button,input,label,select,textarea,details,[role="button"],[role="link"]')) return;
    const radio = card.querySelector('input[name="bundle_purchase_type"]');
    if (radio && !radio.disabled && !radio.checked) {
      radio.focus({preventScroll:true});
      radio.click();
    }
  }));
  renderPurchase(false);
  // Purchase controls use the actual bundle allocation; connectCommerce verifies the shared cart configuration.
  $('[data-bp-purchase]').dataset.ready = 'true';
  $('[data-bp-change]').addEventListener('click', () => {
    $('[data-bp-purchase]').scrollIntoView({behavior:reduced.matches ? 'instant' : 'smooth', block:'start'});
    $('[data-bp-purchase]').focus({preventScroll:true});
  });
  const bundleGiftsReady = true;
  let commerce;
  let adding = false;
  const buyButtons = [$('[data-bp-buy]'), $('[data-bp-sticky-cta]')?.closest('button')].filter(Boolean);
  function connectCommerce() {
    commerce = window.MasiCart;
    const variant = commerce?.variant(config.variantId);
    const plan = variant?.plans?.find(item => Number(item.id) === Number(config.planId));
    if (!variant?.available || !plan || !config.available || plan.price !== config.subscription || variant.price !== config.reference) return;
    buyButtons.forEach(button => { button.disabled = !bundleGiftsReady; });
    root.dataset.bpCommerce = 'ready';
  }
  async function buy(event) {
    if (!commerce || adding || commerce.isBusy() || root.dataset.bpCommerce !== 'ready') return;
    const trigger = event.currentTarget;
    adding = true;
    buyButtons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    const error = $('[data-bp-purchase-error]');
    error.hidden = true;
    const item = {id:config.variantId, quantity:Number($('input[name="bundle_quantity"]:checked').value)};
    if ($('input[name="bundle_purchase_type"]:checked').value === 'subscription') item.selling_plan = config.planId;
    try {
      await commerce.add(item);
      if (document.querySelector('masi-cart-drawer')?.controller) document.dispatchEvent(new CustomEvent('masi:cart:open', {detail:{trigger}}));
      else location.assign(commerce.config.root.replace(/\/$/, '') + '/cart');
    } catch (failure) {
      error.textContent = failure.message || commerce.config.strings.error;
      if (commerce.uncertain) {
        const link = document.createElement('a');
        link.href = commerce.config.root.replace(/\/$/, '') + '/cart';
        link.textContent = commerce.config.strings.retry;
        error.append(document.createTextNode(' '), link);
      }
      error.hidden = false;
      error.focus();
    } finally {
      adding = false;
      buyButtons.forEach(button => { button.disabled = commerce.uncertain; button.removeAttribute('aria-busy'); });
    }
  }
  buyButtons.forEach(button => button.addEventListener('click', buy));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectCommerce, {once:true});
  else connectCommerce();
  const details = all('.bp-hero-details > details');
  const detailsToggle = $('[data-bp-details-toggle]');
  function updateDetails() {
    const expanded = details.every(detail => detail.open);
    detailsToggle.setAttribute('aria-expanded', String(expanded));
    detailsToggle.textContent = expanded ? strings.collapse : strings.expand;
  }
  detailsToggle.addEventListener('click', () => {
    const open = !details.every(detail => detail.open);
    details.forEach(detail => { detail.open = open; });
    updateDetails();
  });
  details.forEach(detail => detail.addEventListener('toggle', updateDetails));
  const reviews = JSON.parse($('[data-bp-reviews]').textContent);
  // Shopify escapes locale text before JSON transport. Decode it once, then use textContent.
  const reviewDecoder = document.createElement('textarea');
  reviews.forEach(review => {
    ['name', 'title', 'body', 'fullBody', 'product'].forEach(field => {
      reviewDecoder.innerHTML = review[field];
      review[field] = reviewDecoder.value;
    });
  });
  const filters = all('[data-bp-review-filter]');
  const slots = all('[data-bp-review]');
  function fillReview(slot, review) {
    const card = slot.querySelector('article');
    card.replaceChildren();
    slot.dataset.reviewId = review.id;
    function element(tag, className, text) {
      const el = document.createElement(tag);
      el.className = className;
      el.textContent = text;
      card.append(el);
      return el;
    }
    element('span', 'funnel-gold-stars', '★'.repeat(review.rating)).setAttribute('aria-label', strings.stars.replace('[rating]', review.rating));
    element('h3', '', review.title);
    const body = element('p', 'funnel-review-body', review.body);
    if (review.fullBody !== review.body) {
      const button = element('button', 'funnel-review-expand', strings.readFull);
      button.type = 'button';
      body.id = 'bp-review-' + review.id;
      button.setAttribute('aria-controls', body.id);
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        body.textContent = expanded ? review.fullBody : review.body;
        button.textContent = expanded ? strings.showLess : strings.readFull;
        button.setAttribute('aria-expanded', String(expanded));
      });
    }
    element('p', 'funnel-review-name', review.name);
    element('p', 'bp-review-product', review.product);
  }
  function filterReviews(button, announce) {
    const category = button.dataset.bpReviewFilter;
    let selected;
    if (category === 'all') selected = config.defaultReviews.map(id => reviews.find(review => review.id === id));
    else selected = reviews.filter(review => review.component === category).slice(0, 4);
    selected.forEach((review, index) => fillReview(slots[index], review));
    filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
    if (announce) $('[data-bp-review-status]').textContent = strings.reviewStatus.replace('[product]', button.textContent).replace('[count]', selected.length);
  }
  filters.forEach(button => button.addEventListener('click', () => filterReviews(button, true)));
  filterReviews(filters[0], false);
  const video = $('[data-bp-review-video]');
  const videoToggle = $('[data-bp-video-toggle]');
  if (video && videoToggle) {
  function resetVideo(failed) {
    video.pause();
    video.hidden = true;
    video.controls = false;
    videoToggle.hidden = false;
    $('[data-bp-video-error]').hidden = !failed;
  }
  videoToggle.addEventListener('click', async () => {
    video.hidden = false;
    video.controls = true;
    videoToggle.hidden = true;
    $('[data-bp-video-error]').hidden = true;
    try { await video.play(); video.focus(); } catch { resetVideo(true); videoToggle.focus(); }
  });
  video.addEventListener('error', () => resetVideo(true));
  video.addEventListener('ended', () => resetVideo(false));
  document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
  }
  const labFilters = all('[data-bp-lab-filter]');
  function filterLabs(button) {
    labFilters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
    all('[data-bp-lab]').forEach(panel => { panel.hidden = panel.dataset.bpLab !== button.dataset.bpLabFilter; });
  }
  labFilters.forEach(button => button.addEventListener('click', () => filterLabs(button)));
  filterLabs(labFilters[0]);
  if ('IntersectionObserver' in window) {
    // Match the current PDP: keep the summary above Shopify's preview toolbar.
    let stickyFrame = 0;
    let toolbarObserved;
    const resize = new ResizeObserver(scheduleSticky);
    function updateSticky() {
      stickyFrame = 0;
      const viewportTop = window.visualViewport?.offsetTop || 0;
      const viewportBottom = viewportTop + (window.visualViewport?.height || innerHeight);
      const toolbar = document.getElementById('PBarNextFrameWrapper');
      if (toolbar !== toolbarObserved) {
        if (toolbarObserved) resize.unobserve(toolbarObserved);
        toolbarObserved = toolbar;
        if (toolbar) resize.observe(toolbar);
      }
      const box = toolbar?.getBoundingClientRect();
      const style = toolbar && getComputedStyle(toolbar);
      const height = box?.height > 0 && box.height <= 120 && Math.abs(box.bottom - viewportBottom) <= 2 && style.visibility === 'visible' && Number(style.opacity) > 0 ? Math.ceil(box.height) : 0;
      root.style.setProperty('--masi-preview-bar', height + 'px');
      $('[data-bp-sticky]').hidden = $('.bp-purchase .cta').getBoundingClientRect().bottom >= viewportTop;
    }
    function scheduleSticky() {
      if (!stickyFrame) stickyFrame = requestAnimationFrame(updateSticky);
    }
    addEventListener('scroll', scheduleSticky, {passive:true});
    addEventListener('resize', scheduleSticky);
    window.visualViewport?.addEventListener('resize', scheduleSticky);
    window.visualViewport?.addEventListener('scroll', scheduleSticky, {passive:true});
    resize.observe($('.product-info'));
    new ResizeObserver(entries => {
      const height = entries[0].borderBoxSize?.[0]?.blockSize;
      if (height > 0) root.style.setProperty('--sticky-clearance', (Math.ceil(height) + 24) + 'px');
    }).observe($('[data-bp-sticky]'));
    scheduleSticky();
    if (video) new IntersectionObserver(entries => { if (!entries[0].isIntersecting) video.pause(); }, {threshold:0}).observe(video);
    if (!reduced.matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bp-visible');
        observer.unobserve(entry.target);
      }), {rootMargin:'0px 0px 40px 0px', threshold:0.06});
      all('[data-bp-reveal]').forEach(element => { element.classList.add('bp-ready'); observer.observe(element); });
    }
  }
  root.dataset.bpReady = 'true';
})();
